<template>
  <div class="components-container">
    <header>
      <span class="title">组件管理</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button size="small" @click="dialogDelete = true" :disabled="multipleSelection.length === 0" v-if="funAuth.includes(57)">删  除</el-button>
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(55)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @row-click="rowClick" @selection-change="handleSelectionChange">
      <el-table-column type='selection' width='55' :selectable="selectable"></el-table-column>
      <el-table-column prop='cm_name' label='名称' min-width='260'></el-table-column>
      <el-table-column prop='cm_state' label='状态' min-width='140'>
        <template slot-scope='scope'>{{ scope.row.cm_state === '1' ? '启用' : '禁用' }}</template>
      </el-table-column>
      <el-table-column prop='use_custom' label='已使用客户数' min-width='140'></el-table-column>
      <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
      <el-table-column label='创建时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n1" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <component-detail v-if="dialogDetail" :component="componentDtl"></component-detail>
    </transition>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <component-add v-if="dialogAdd" :component="{}"></component-add>
    </transition>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">只有停用状态的数据才允许删除。</div>
      <div class="prompt">定要删除该数据吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="delComponentManage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import componentDetail from '@/page/business/component-detail'// 详情
import componentAdd from '@/page/business/component-add'// 新增
import {HTTPServer} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>组件管理</b>',
      searchInput: '',
      disabled: false,
      tableList: [],
      moduleId: 7,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      multipleSelection: [],
      componentDtl: {},
      dialogDetail: false,
      dialogAdd: false,
      dialogDelete: false
    }
  },
  components: {
    componentDetail,
    componentAdd
  },
  mixins: [mixin],
  mounted () {
    this.getComponentManageList()
    this.queryFchBtnAuth(({moduleId: 17}))
    /** 增购 - 列表更新 */
    this.$bus.off('query-component-list')
    this.$bus.on('query-component-list', (value, page) => {
      if (value) {
        this.getComponentManageList()
        if (page) {
          this.pageNum = 1
          this.searchValue = ''
        }
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      console.log(value)
      if (value) {
        this.dialogAdd = false
      }
    })
    // 关闭详情窗口
    this.$bus.on('closeAddDetailModal', (value) => {
      console.log(value)
      if (value) {
        this.dialogDetail = false
      }
    })
  },
  methods: {
    /** 获取 组件管理 */
    getComponentManageList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'searchContent': this.searchValue}
      HTTPServer.getComponentManageList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getComponentManageList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.getComponentManageList()
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.getComponentManageList()
    },
    /** 新增增购弹窗 */
    AddDialog () {
      this.dialogAdd = true
    },
    /** 进入增购详情 */
    rowClick (row, event, column) {
      console.log(row, event, column)
      this.activeNames = ['1', '2', '3']
      this.componentDtl = row
      this.tabType = 0
      this.dialogDetail = true
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    delComponentManage () {
      let arr = []
      this.multipleSelection.map((item) => {
        arr.push(item.id)
      })
      var jsondata = {'id': arr.toString()}
      HTTPServer.delComponentManage(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('closeAddDetailModal', true)
        this.$bus.emit('query-component-list', true, true)
      })
    },
    // 移除默认
    selectable (row, index) {
      return !(row.cm_default === '1' || row.cm_state === '1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/component.vue